module.exports = __webpack_public_path__ + "img/01.e50a07df.jpg";